import React from "react";
import { Check } from "lucide-react";
import { AppStoreBadge, PlayStoreBadge } from "./StoreBadges";

const free = [
  "Unlimited Americano tournaments",
  "Live point-by-point scoring",
  "All match formats + Golden Point",
  "Community player directory",
  "Career stats & rankings",
  "Podium & shareable results",
];

const pro = [
  "Everything in Free",
  "Advanced player analytics",
  "Club & multi-court management",
  "Custom branding & exports",
  "Priority support",
  "Early access to new features",
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-20 md:py-24 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
            Pricing
          </div>
          <h2
            data-testid="pricing-heading"
            className="font-display uppercase tracking-tight text-5xl md:text-7xl leading-[0.9]"
          >
            Free to play.
            <br />
            <span className="text-[#D4F34A]">Forever.</span>
          </h2>
          <p className="mt-6 text-neutral-400 max-w-lg text-sm md:text-base">
            Every core feature is free — tournaments, live scoring, stats and
            community. Pro tier unlocks club-grade tools when you&apos;re ready.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {/* Free */}
          <div
            data-testid="pricing-free"
            className="relative border-2 border-[#D4F34A] p-8 md:p-10 bg-neutral-950"
          >
            <div className="absolute -top-3 left-8 bg-[#D4F34A] text-black text-[10px] uppercase tracking-widest font-bold px-3 py-1">
              Available now
            </div>
            <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
              Rallie · Free
            </div>
            <div className="flex items-baseline gap-2 mb-8">
              <span className="font-display text-7xl md:text-8xl leading-none">
                $0
              </span>
              <span className="text-neutral-500 uppercase text-xs tracking-widest">
                / forever
              </span>
            </div>

            <ul className="space-y-3 mb-10">
              {free.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm">
                  <Check size={16} className="text-[#D4F34A] mt-1 flex-none" />
                  <span className="text-neutral-200">{item}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-3">
              <AppStoreBadge testId="pricing-app-store" />
              <PlayStoreBadge testId="pricing-play-store" />
            </div>
          </div>

          {/* Pro */}
          <div
            data-testid="pricing-pro"
            className="relative border border-neutral-800 p-8 md:p-10 bg-black"
          >
            <div className="absolute -top-3 left-8 bg-neutral-900 text-neutral-400 text-[10px] uppercase tracking-widest font-bold px-3 py-1 border border-neutral-800">
              Coming soon
            </div>
            <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">
              Rallie · Pro
            </div>
            <div className="flex items-baseline gap-2 mb-8">
              <span className="font-display text-7xl md:text-8xl leading-none text-neutral-500">
                Soon
              </span>
            </div>

            <ul className="space-y-3 mb-10">
              {pro.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm">
                  <Check size={16} className="text-neutral-500 mt-1 flex-none" />
                  <span className="text-neutral-400">{item}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="pricing-waitlist"
              disabled
              className="w-full border border-neutral-800 text-neutral-500 uppercase tracking-widest text-xs py-4 cursor-not-allowed"
            >
              Notify me
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
